export const handelUndefined = (value: string | null | undefined) => {
  if (value?.includes("undefined") || value == null) {
    return "Address coming soon!";
  }

  return value;
};
